'use strict';

exports.__esModule = true;
exports['default'] = isDisposable;

function isDisposable(obj) {
  return Boolean(obj && typeof obj.dispose === 'function');
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/disposables/modules/isDisposable.js
 ** module id = 788
 ** module chunks = 0
 **/